
import { HeroServiceSection } from "@/components/services/HeroServiceSection";

export const LaserDentistryHero = () => {
  const handleBookAppointment = () => {
    window.open("https://www.healthcoco.com/nagpur/doctor/dr-hemant-asrani-endodontist-dentist/USRH249D644", "_blank");
  };

  return (
    <HeroServiceSection 
      title="Laser Dentistry in Nagpur"
      description="Advanced, comfortable dental care using state-of-the-art laser technology at Asrani Dental, Sadar, Nagpur."
      onButtonClick={handleBookAppointment}
    />
  );
};
